export const isPhoneNum = function(str) {
  return /^((1[3-8][0-9])+\d{8})$/.test(str.trim());
};

export const replaceEmoji = function(str) {
  const rt = !!str ? str.replace(/[\u2190-\u21FF]|[\u2600-\u26FF]|[\u2700-\u27BF]|[\u3000-\u303F]|[\u1F300-\u1F64F]|[\u1F680-\u1F6FF]/g, '') : '';
  return rt
};

export const checkEmoji = function(str){
  return/[\u2190-\u21FF]|[\u2600-\u26FF]|[\u2700-\u27BF]|[\u3000-\u303F]|[\u1F300-\u1F64F]|[\u1F680-\u1F6FF]/g.test(str.trim());
}
